import { Button } from '@mui/material'
import React, { useEffect } from 'react'
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

export default function ExportExcel({ excelClick, header, excelData, fileName }) {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  useEffect(() => {
    if (excelClick) {
      exportToXlsx(header, excelData, fileName);
    }
  }, [excelClick]);

  const exportToXlsx = (header, excelData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(excelData, header);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <div>
      <Button variant="contained" startIcon={<SaveAltIcon />}>
        엑셀출력
      </Button>
    </div>
  );
}
